import React, { forwardRef } from 'react';
import { CSSObject } from 'styled-components';

import { OverlayStyled } from './overlay.styled';

interface OverlayProps {
  sx?: CSSObject;
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
  onMouseDown?: (event: React.MouseEvent<HTMLDivElement>) => void;
  onMouseUp?: (event: React.MouseEvent<HTMLDivElement>) => void;
  children?: React.ReactNode | React.ReactNode[];
}

const Overlay = forwardRef((props: OverlayProps, ref: any) => {
  const { children, onClick, onMouseDown, onMouseUp, sx } = props;

  return (
    <OverlayStyled
      ref={ref}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
      onClick={onClick}
      sx={sx}
    >
      {children}
    </OverlayStyled>
  );
});

Overlay.displayName = 'Overlay';

export default Overlay;
